import React from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import cx from 'classnames';
import { connect } from 'react-redux';
import { pluck } from 'underscore';

// ducks
import { CONTACT_SUBMIT } from '../../ducks/Home';

// components
import ContactAgentForm from '../../forms/contact-agent-form/contact-agent-form';

// modules
import BS from '../../theme/Bootstrap';

let FavoriteSearchContactAgentModal = props => {
  const {
    className,
    isOpen,
    onToggle,
    propertyClass,
    mlsIds = [],
    CONTACT_SUBMIT,
    title,
    ...modalProps
  } = props;

  return (
    <Modal
      className={cx(className, BS.modalDialogCentered)}
      isOpen={isOpen}
      toggle={onToggle}
      {...modalProps}
    >
      <ModalHeader
        toggle={() => {
          onToggle(false);
        }}
      >
        {title}
      </ModalHeader>
      <ModalBody>
        <ContactAgentForm
          title={''}
          onCancelClick={() => onToggle(false)}
          enableReinitialize={true}
          initialValues={{
            id: mlsIds.join(','),
            type: 'property'
          }}
          onSubmit={(values, dispatch, props) => {
            return CONTACT_SUBMIT(values).then(function () {
              setTimeout(() => onToggle(false), 1000);
            });
          }}
        />
      </ModalBody>
    </Modal>
  );
};

FavoriteSearchContactAgentModal.defaultProps = {
  title: 'Contact Agents'
};

export default connect(
  (state, props) => {
    var mlsIds = props.mlsIds;

    if (!mlsIds) {
      const { propertyClass = 'residential' } = props;
      const favorites = state.FavoriteSearch.get('favorites')
        .filter(favorite => {
          return favorite.get('propertyClass') === propertyClass;
        })
        .toJS();
      mlsIds = pluck(favorites, 'mlsNumber');
    }

    return {
      mlsIds
    };
  },
  {
    CONTACT_SUBMIT
  }
)(FavoriteSearchContactAgentModal);



// WEBPACK FOOTER //
// ./src/containers/FavoriteSearch/FavoriteSearchContactAgentModal.js